import {defineStore} from "pinia";
import {Icon} from "../base-components/Lucide/Lucide.vue";

export interface Menu {
    icon?: Icon;
    title: string;
    pageName?: string;
    subMenu?: Menu[];
    ignore?: boolean;
    invisible?: boolean;
    roles?: string[]
}

export interface SideMenuState {
    menu: Array<Menu | "divider">;
}


export const useSideMenuStore = defineStore("sideMenu", {
    state: (): SideMenuState => ({
        menu: [
            {
                icon: "LayoutDashboard",
                pageName: "side-menu-dashboard-overview-1",
                title: "menu.dashboard",
            },
            {
                icon: "Server",
                pageName: "side-menu-list-vm-server",
                title: "menu.vm-server",
            },
            // {
            //     icon: "Server",
            //     pageName: "side-menu-list-vm-server",
            //     title: "title.iaas",
            //     subMenu: [
            //         {
            //             icon: "Plus",
            //             pageName: "side-menu-create-vm-server",
            //             title: "menu.create-server",
            //         },
            //
            //         {
            //             icon: "Server",
            //             pageName: "side-menu-view-vm-server",
            //             title: "menu.vm-server",
            //             invisible: true
            //         },
            //     ]
            // },
            {
                icon: "Send",
                pageName: "ticket-list",
                title: "menu.ticket",
            },
            {
                icon: "Wallet",
                pageName: "account.wallet",
                title: "menu.wallet",
            },
            {
                icon: "ShoppingBasket",
                pageName: "account.transaction",
                title: "menu.transaction",
            },
            {
                icon: "ListTodo",
                pageName: "account.invoice",
                title: "menu.invoice",
            },
            // {
            //     icon: "Banknote",
            //     pageName: "side-menu-list-vm-server",
            //     title: "menu.financial",
            //     subMenu: [
            //
            //         {
            //             icon: "Server",
            //             pageName: "side-menu-view-vm-server",
            //             title: "menu.vm-server",
            //             invisible: true
            //         },
            //     ]
            // },
            "divider",
            {
                icon: "Settings",
                pageName: "manager",
                title: "menu.manager",
                roles: ["DomainAdmin", "Support"],
                subMenu: [
                    {
                        icon: "BarChart4",
                        pageName: "manager-report",
                        title: "menu.report",
                    },
                    {
                        icon: "Users",
                        pageName: "manager-users",
                        title: "menu.users",

                        subMenu: [
                            {
                                pageName: "manager-users-list",
                                title: "menu.list",
                                icon: "Activity",
                            }
                        ],
                    },
                    {
                        icon: "Wallet",
                        pageName: "manager-financial",
                        title: "menu.financial",
                        subMenu: [
                            {
                                pageName: "manager-financial-wallet",
                                title: "menu.wallet",
                                icon: "Activity",
                            },
                            {
                                pageName: "manager-financial-ipg",
                                title: "menu.ipg",
                                icon: "Activity",
                            },
                            {
                                pageName: "manager-financial-pricing",
                                title: "menu.pricing",
                                icon: "Activity",
                                roles: ["DomainAdmin"],

                            }
                        ],
                    },
                    {
                        icon: "MessageCircle",
                        pageName: "manager-support",
                        title: "menu.support",

                        subMenu: [
                            {
                                pageName: "manager-support-ticket",
                                title: "menu.ticket",
                                icon: "Activity",
                            },
                            {
                                pageName: "manager-support-department",
                                title: "menu.department",
                                icon: "Activity",
                            }
                        ],
                    },
                    {
                        icon: "Server",
                        pageName: "manage-side-menu-server",
                        title: "menu.vm-server",
                        subMenu: [
                            {
                                icon: "Activity",
                                pageName: "manage-side-menu-list-vm-server",
                                title: "menu.list-vm-server",
                            },
                        ],
                    },
                    {
                        icon: "Shield",
                        pageName: "manager-rbac-roles",
                        title: "menu.rbac",
                        roles: ["root"],
                    },

                ],
            },
            "divider",
            {
                icon: "Cloud",
                pageName: "manage-side-menu-cloud",
                title: "menu.cloud",
                roles: ["CloudAdmin"],
                subMenu: [
                    {
                        icon: "Cog",
                        pageName: "manage-side-menu-cloud-list",
                        title: "menu.infrastructure",
                    },
                    {
                        icon: "ServerCog",
                        pageName: "manage-side-menu-cloud-pricing",
                        title: "menu.cloudPricing",
                    },
                    {
                        icon: "HandCoins",
                        pageName: "manage-side-menu-domain-pricing",
                        title: "menu.domainPricing",
                    },
                ],
            },

        ],
    }),
});
